import { createStore } from "./createStore";

const base = (set, get) => ({
  turnId: null,
  turnChangeFailed: false,
  setTurnChangeFailed: (turnChangeFailed) => set({ turnChangeFailed }),
  resumeTurnLockUntilMs: 0,
  setTurnId: (turnId) => set({ turnId, turnChangeFailed: false }),
  getTurnId: () => get().turnId,
  lockResumeTurnChanges: (durationMs = 8000) =>
    set({
      resumeTurnLockUntilMs: Date.now() + Math.max(0, Number(durationMs) || 0),
    }),
  clearResumeTurnLock: () => set({ resumeTurnLockUntilMs: 0 }),
  isResumeTurnLocked: () => Date.now() < (get().resumeTurnLockUntilMs || 0),
  getResumeTurnLockUntilMs: () => get().resumeTurnLockUntilMs || 0,
});

export const useTurnStore = createStore("TurnStore", base);
